<template>
  <div class="szw-h-full szw-w-full szw-absolute szw-top-0 szw-left-0 szw-backdrop-blur-xs szw-bg-black/10 szw-z-50" @click="toggleLegends">
    <div class="szw-flex szw-flex-col szw-justify-end szw-h-full szw-w-full szw-max-w-[768px] szw-mx-auto szw-relative">
      <div class="szw-absolute szw-top-2.5 szw-right-2.5 szw-bg-background szw-rounded-md szw-w-64 szw-p-2.5">
        <div class="szw-row__between szw-h-8 szw-items-center szw-w-full">
          <span class="szw-text-xs szw-font-semibold">{{ loc('sm_color_legend', langId) }}</span>

          <div class="szw-cursor-pointer" @click="toggleLegends" e2e-id="standings-legends-close">
            <sprite sprite-id="close" color="var(--szw-text-icon-primary)" />
          </div>
        </div>

        <div class="szw-row szw-h-9 szw-items-center szw-w-full szw-gap-3" v-for="(marker, index) of props.standingsMarkers" :key="index">
          <span class="szw-h-2 szw-w-2 szw-rounded-xl" :style="{ background: marker.color }" />
          <span class="szw-text-xxs szw-uppercase szw-tracking-wider">{{ marker.type }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Sprite from '@/__core__/components/sprite/Sprite.vue'
import { inject } from 'vue'

const props = defineProps({
  standingsMarkers: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['toggle-legends'])

const langId = inject('langId', '')

const toggleLegends = () => {
  emit('toggle-legends')
}
</script>
